import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
/**
 * Created by h3 on 2017-05-31.
 */
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";

export class TractorBeamFreeSpinIntroScreenView extends ScreenView {

    private readonly DEFAULT_BUTTON:PIXI.Point = new PIXI.Point(240, 64);

    private _textWith:number;
    private _container:PIXI.Container;
    private _textPanel:PIXI.Sprite;

    private _infoText:PIXI.Text;
    private _bg:PIXI.Sprite;

    public isPortrait:boolean = false;

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
    }

    initAnimations() {
        super.initAnimations();

        //this._button.position.set(100, 100);
        //this._button.alpha = 1;
        //this._button.visible = true;

        //this._layer.addChild(this);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const container:PIXI.Container = new PIXI.Container();

        const bg:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fsIntro")[0]);
        bg.anchor.set(0.115, 0.29);
        this._bg = bg;
        //bg.position.set(430, 100);

        const textBg:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fsTextBg")[0]);
        textBg.position.set(380, 170);
        this._textPanel = textBg;

        // Info text stuff
        const x:number = this._textPanel.width / 2;
        const y:number = this._textPanel.height;

        this._infoText = new PIXI.Text("Explanations", {
            fill : 0xffffff,
            fontFamily : "Open Sans",
            wordWrap : true,
            wordWrapWidth : 230,
            fontSize : 22,
            breakWords : true
        });
        this._infoText.anchor.set(0.5, 0);
        this._infoText.position.set(x + 70, 155);
        this._infoText.text = Translation.translate("All winning symbols will be abducted - until only Wilds exists on the reels!");


        container.addChild(bg);
        container.addChild(textBg);
        this._textPanel.addChild(this._infoText);

        this._container = container;


        return container;
    }

    protected onResize(resizeData:IResizeData):void {
        //super.onResize(resizeData);
        this._orientationScale = resizeData.orientation === Orientation.PORTRAIT ? (this._config.portraitScale ? this._config.portraitScale : this.DEFAULT_PORTRAIT_SCALE) : 1;

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._container.y = 100;
            this._bg.x = -120;
            this._bg.y = 35;

            this._bg.scale.set(1.2, 1.2);
            this.isPortrait = true;
        } else {
            this._container.y = 0;
            this._bg.y = 0;
            this._bg.x = 0;
            this._bg.scale.set(1, 1);
            this.isPortrait = false;
        }

        this.onResizeButton(resizeData);


        this.onResizeAutoCloseTimer(resizeData);

        //this._textPanel.scale.set(this._deviceScale, this._deviceScale); NO


        //this.onResizeButton(resizeData);
        /*if(!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }

        this._screenWidth = resizeData.width / this._layer.scale.x;
        this._screenHeight = resizeData.height / this._layer.scale.y;
        this._orientationScale = resizeData.orientation === Orientation.PORTRAIT ? (this._config.portraitScale ? this._config.portraitScale : this.DEFAULT_PORTRAIT_SCALE) : 1;

        if(this.createBackground && this.onResizeBackground) {
            this.onResizeBackground(resizeData);
        }

        this.onResizeButton(resizeData);

        if(this._autoClose) {
            this.onResizeAutoCloseTimer(resizeData);
        }

        if(this.createGameGraphics && this.onResizeGameGraphics) {
            this.onResizeGameGraphics(resizeData);
        }

        //Negate layer scaling offset.
        this.x = -this._layer.x / this._layer.scale.x;
        this.y = -this._layer.y / this._layer.scale.y;

        this._isResizeDirty = false;*/
    }

    private getScaledButton():PIXI.Point {
        const buttonSize:PIXI.Point = this._config.buttonSize ? this._config.buttonSize : this.DEFAULT_BUTTON;
        return new PIXI.Point(buttonSize.x * this._deviceScale, buttonSize.y * this._deviceScale);
    }

    protected onResizeAutoCloseTimer(data:IResizeData):void {
        // const scale:number = this._orientationScale * this._deviceScale;//(data.orientation === Orientation.PORTRAIT)? 2 : 1.75;
        // this._autoCloseTimer.setScale(scale);
        // this._autoCloseTimer.position.set(this._button.x, this._button.y + this._button.height * 0.5 + this._autoCloseTimer.height);
    }

    protected onResizeButton(data:IResizeData):void {
        const buttonSize:PIXI.Point = this.getScaledButton();
        this._button.setSize(buttonSize.x, buttonSize.y, 1);

        if(data.orientation === Orientation.PORTRAIT) {
            this._button.scale.set(1, 1);
        } else {
            this._button.scale.set(1, 1);
            //this._button.scale.set(0.85, 0.85);
        }

        this.setButtonPosition(data);
    }

    protected setButtonPosition(data:IResizeData):void {
        if(data.orientation === Orientation.PORTRAIT) {
            this._button.position.set(650, 795)
        } else {
            if(UserAgent.isMobile) {
                this._button.position.set(650, 570);
            } else {
                this._button.position.set(650, 625);
            }
        }
    }

    //public show():void {
    //this._isShowing = true;
    //if(this._isResizeDirty) {
    //this.onResize(this._resizeData);
    //}
    //this._layer.addChild(this);
    //this.startPresentation(data, onShowComplete);
    //}

}
